import { NotificationProps } from './@types'

import { Core, Title, Wrap } from './Style'

export const Notification = (props: NotificationProps) => {
  const {
    type,
    title,
    onClick,
    message,
    round = '0.8rem',
    margin = '0 auto',
    align = 'flex-start',
    isClickable = false,
    children,
  } = props

  return (
    <Wrap margin={margin}>
      <Core type={type} align={align} round={round} isClickable={isClickable} onClick={onClick}>
        {title && <Title>{title}</Title>}
        {message && message}
        {children}
      </Core>
    </Wrap>
  )
}
